var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { List, OrderedList } from '@telus-uds/components-web';
import { RICH_TEXT_TYPES } from '../../types';
var BLOCKS = RICH_TEXT_TYPES.BLOCKS;
export var buildListFunctions = function (listOptions) {
    var _a;
    return _a = {},
        _a[BLOCKS.UL_LIST] = function (_node, children) {
            return Array.isArray(children) ? (_jsx(List, __assign({}, listOptions === null || listOptions === void 0 ? void 0 : listOptions.list, { children: children === null || children === void 0 ? void 0 : children.map(function (child) { return (_jsx(List.Item, __assign({}, listOptions === null || listOptions === void 0 ? void 0 : listOptions.item, { children: child.props.children.map(function (nestedChild) { return nestedChild; }) }), child.key)); }) }))) : (children);
        },
        _a[BLOCKS.OL_LIST] = function (_node, children) {
            return Array.isArray(children) ? (_jsx(OrderedList, __assign({}, listOptions === null || listOptions === void 0 ? void 0 : listOptions.list, { children: children.map(function (child) { return (_jsx(OrderedList.Item, __assign({}, listOptions === null || listOptions === void 0 ? void 0 : listOptions.item, { children: child.props.children.map(function (nestedChild) { return nestedChild; }) }), child.key)); }) }))) : (children);
        },
        _a;
};
